export default "__VITE_ASSET__CcuglCKk__"